module.exports = __webpack_public_path__ + "static/media/ilustracion5.8799451b.png";